/*
 * Country selector polish for Dawn's localization forms (header, menu drawer, footer):
 * Shopify CDN flags, short country names and a compact button. Full names stay in the DOM for
 * Dawn's country search, screen readers and the hover title.
 */
(() => {
  const script = document.currentScript;
  const sampleUrl = script?.dataset.flagUrl || '';
  const sampleIso = script?.dataset.flagIso || '';
  const isEnglish = (document.documentElement.lang || 'en').toLowerCase().startsWith('en');

  const SHORT_NAMES = {
    AE: 'UAE',
    AG: 'Antigua',
    BA: 'Bosnia',
    BL: 'St. Barthélemy',
    BQ: 'Bonaire',
    CC: 'Cocos Islands',
    CD: 'DR Congo',
    CF: 'Central African Rep.',
    CG: 'Congo',
    DO: 'Dominican Rep.',
    GB: 'UK',
    GS: 'South Georgia',
    HM: 'Heard Island',
    IO: 'Br. Indian Ocean',
    KN: 'St. Kitts',
    MF: 'St. Martin',
    MK: 'N. Macedonia',
    PM: 'St. Pierre',
    PS: 'Palestine',
    SH: 'St. Helena',
    SJ: 'Svalbard',
    ST: 'São Tomé',
    TC: 'Turks & Caicos',
    TF: 'French S. Territories',
    TT: 'Trinidad & Tobago',
    UM: 'U.S. Islands',
    US: 'USA',
    VA: 'Vatican',
    VC: 'St. Vincent',
    VG: 'British Virgin Is.',
    WF: 'Wallis & Futuna',
  };

  const flagUrl = (iso) => {
    const code = iso.toLowerCase();
    if (sampleUrl && sampleIso && sampleUrl.includes(`/${sampleIso}.svg`)) {
      return sampleUrl.replace(`/${sampleIso}.svg`, `/${code}.svg`);
    }
    return `https://cdn.shopify.com/static/images/flags/${code}.svg?width=48`;
  };

  const shortName = (iso, name) => (isEnglish && SHORT_NAMES[iso]) || name;

  const createFlag = (iso, lazy) => {
    const img = document.createElement('img');
    img.className = 'chyde-flag';
    img.src = flagUrl(iso);
    img.alt = '';
    img.width = 20;
    img.height = 15;
    img.decoding = 'async';
    if (lazy) img.loading = 'lazy';
    return img;
  };

  const createSpan = (className, text, hidden) => {
    const span = document.createElement('span');
    span.className = className;
    span.textContent = text;
    if (hidden) span.setAttribute('aria-hidden', 'true');
    return span;
  };

  const currencyCode = (text) => text.trim().split(/\s+/)[0] || '';

  function enhanceLinks(form) {
    form.querySelectorAll('a.disclosure__link[data-value]').forEach((link) => {
      if (link.dataset.chydeLocale) return;
      const iso = link.dataset.value;
      const country = link.querySelector('.country');
      if (!iso || !country) return;

      const fullName = country.textContent.trim();
      const label = shortName(iso, fullName);
      if (label !== fullName) {
        country.replaceChildren(createSpan('', label, true), createSpan('visually-hidden', fullName));
      }
      link.title = fullName;

      const currency = link.querySelector('.localization-form__currency');
      if (currency) currency.textContent = currencyCode(currency.textContent);

      link.prepend(createFlag(iso, true));
      link.dataset.chydeLocale = 'true';
    });
  }

  function enhanceButton(form, iso) {
    const button = form.querySelector('.disclosure__button');
    const label = button?.querySelector(':scope > span');
    if (!label || button.dataset.chydeLocale) return;

    const fullText = label.textContent.replace(/\s+/g, ' ').trim();
    const [name = '', currency = ''] = fullText.split('|').map((part) => part.trim());

    label.classList.add('chyde-locale');
    label.replaceChildren(
      createFlag(iso, false),
      createSpan('chyde-locale__name', shortName(iso, name), true),
      createSpan('chyde-locale__currency', currencyCode(currency), true),
      createSpan('visually-hidden', fullText)
    );
    button.dataset.chydeLocale = 'true';
  }

  function enhance(root = document) {
    root.querySelectorAll('localization-form').forEach((form) => {
      const input = form.querySelector('input[name="country_code"]');
      if (!input) return;
      form.classList.add('chyde-country-form');
      enhanceButton(form, input.value);
      enhanceLinks(form);
    });
  }

  enhance();
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
